import { render } from "./DatabaseApp.vue?vue&type=template&id=8dd19746&ts=true"
import script from "./DatabaseApp.vue?vue&type=script&lang=ts"
export * from "./DatabaseApp.vue?vue&type=script&lang=ts"

import "./DatabaseApp.vue?vue&type=style&index=0&id=8dd19746&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__